import { render } from "./StepTwoForm.vue?vue&type=template&id=0c95d805"
import script from "./StepTwoForm.vue?vue&type=script&lang=js"
export * from "./StepTwoForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__